import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type {
  IApiGetIapPollResultsQueryBody,
  IApiGetIapPollResultsResponseBody,
} from '../IapPollsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseIapPollResultsQueryValues = {
  appId: string;
  iapPollId: string;
  body?: IApiGetIapPollResultsQueryBody;
};

export const pollResultsQueryKeyFactory: IQueryKeyFactory<
  IUseIapPollResultsQueryValues
> = (values) =>
  values &&
  (values.body
    ? (['iapPollResults', values.appId, values.iapPollId, values.body] as const)
    : (['iapPollResults', values.appId, values.iapPollId] as const));

export const useIapPollResultsQuery = (
  values?: IUseIapPollResultsQueryValues,
  options?: UseQueryOptions<IApiGetIapPollResultsResponseBody, ApiError>,
): UseQueryResult<IApiGetIapPollResultsResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: pollResultsQueryKeyFactory(values),
    queryFn: values
      ? () =>
          api.iapPolls.getResults(values.appId, values.iapPollId, values.body)
      : undefined,
    enabled: !!values,
    ...options,
  });
};
